<p class="control has-icons-left has-icons-right mt-0 mb-2">
  <span
    class="icon is-small is-right pointer close-button"
    (click)="clear()"
    (keydown)="clear()"
    tabindex="0"
    *ngIf="searchEl.nativeElement.value"
  >
    <i class="fas fa-times has-text-primary"></i>
  </span>
  <input
    type="search"
    id="search-input"
    autocomplete="off"
    class="input"
    style="min-width: unset"
    placeholder="{{ placeholder || 'Search by name...' }}"
    #searchInput
  />

  <span class="icon is-small is-left">
    <i class="fas fa-search has-text-grey-dark"></i>
  </span>
</p>
